/* @flow */

import React from 'react';

import { Route } from 'react-router';
import { loadRoute, prepareInfiniteScrollParams, render, ViewerQueries } from 'depop/router';

function prepareProductParams(params, { location }) {
  return {
    ...params,
    id: location.state && location.state.productId,
  };
}

function prepareShopParams(params, { location }) {
  return {
    ...params,
    ...prepareInfiniteScrollParams(params),
    id: location.state && location.state.userId,
  };
}

export default (
  <Route>
    <Route
      path="products/create"
      getComponent={(location, cb) => loadRoute(import('./views/ProductCreate'), cb)}
      queries={ViewerQueries}
      render={render}
      noTrack />
    <Route
      path="products/:slug"
      prepareParams={prepareProductParams}
      getComponent={(location, cb) => loadRoute(import('./views/ProductDetail'), cb)}
      queries={ViewerQueries}
      render={render}
      noTrack />
    <Route
      path=":username/likes"
      prepareParams={prepareShopParams}
      getComponent={(location, cb) => loadRoute(import('./views/ShopLikes'), cb)}
      queries={ViewerQueries}
      render={render} />
    <Route
      path=":username/:slug"
      prepareParams={prepareProductParams}
      getComponent={(location, cb) => loadRoute(import('./views/ProductDetail'), cb)}
      queries={ViewerQueries}
      render={render} />
    <Route
      path=":username"
      prepareParams={prepareShopParams}
      getComponent={(location, cb) => loadRoute(import('./views/ShopDetail'), cb)}
      queries={ViewerQueries}
      render={render} />
  </Route>
);



// WEBPACK FOOTER //
// ../src/client/apps/shops/index.js